import { Stack } from "@mui/material";
import { timeTicks } from "d3";
import PropTypes from "prop-types";
import React from "react";
import MeasureLineChart from "components/Measures/MeasureLineChart";

export default function ChartBloodPressure({ measures, graphs }) {
  const chartData = measures.map((measure) => ({
    ...measure.value,
    timestamp: measure.timestamp,
  }));

  return (
    <Stack spacing={2}>
      {Object.keys(chartData).length === 0 && "No data"}
      <Stack
        direction="row"
        spacing={2}
        sx={{
          py: 2,
        }}
      >
        <Stack sx={{ flex: 2 }}>
          <MeasureLineChart
            sx={{ py: "20px" }}
            data={chartData}
            isShowExportCSVButton={false}
            graphs={graphs}
            lineChartProps={{
              margin: { top: 5, right: 0, left: -25, bottom: 40 },
            }}
            labelProps={{
              sx: { fontSize: "16px" },
            }}
            XAxisProps={{
              scale: "time",
              angle: -30,
              dy: 15,
              ticks: timeTicks(
                new Date(chartData[0].timestamp).valueOf(),
                new Date(chartData[chartData.length - 1].timestamp).valueOf(),
                10
              ),
              interval: 0,
              tickCount: 10,
              padding: { left: 50, right: 30 },
            }}
            tickTimeFormat="M/d p"
            toolTipLabelTimeFormat="M/d p"
          />
        </Stack>
      </Stack>
    </Stack>
  );
}

ChartBloodPressure.propTypes = {
  measures: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      timestamp: PropTypes.string.isRequired,
      systolic: PropTypes.number,
      diastolic: PropTypes.number,
      bpm: PropTypes.number,
      spo2: PropTypes.number,
    })
  ),
  graphs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.arrayOf(
        PropTypes.shape({
          key: PropTypes.string.isRequired,
          color: PropTypes.string,
          bounds: PropTypes.arrayOf(PropTypes.number),
          name: PropTypes.string,
        })
      ).isRequired,
    })
  ).isRequired,
};

ChartBloodPressure.defaultProps = {
  measures: [],
};
